import VueI18n from '../i18n/i18n';
import themeConfig from '../../themeConfig';
import AppConstants from "../appConstants";
import { CONTENT } from '../enums/enum-content';
import convertDatetimeHelper from '../helpers/convert-datetime-helper';
import apiCacheService from './apiCacheService';

class NewsHomeService {
    
    getAllSubjectCache(params) {
        return new Promise((resolve, reject) => {
            apiCacheService.get(AppConstants.URL_API_CACHE_SUBJECT, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }
    
    getAllContentCache(params, isDesktop) {
        return new Promise((resolve, reject) => {
            apiCacheService.get(AppConstants.URL_API_CACHE_CONTENT, params)
                .then(response => {
                    if (response.analysis.length > 0) {
                        response.analysis = response.analysis.map(item => {
                            return {
                                id: item.code,
                                nome: item.namePtBr,
                                namePtBr: item.namePtBr,
                                nameEnEu: item.nameEnEu,
                                nameEsAr: item.nameEsAr,
                                nameEsEs: item.nameEsEs,
                                namePtPt: item.namePtPt,
                                habilitado: item.active,
                                icone: item.icon,
                                isQuotes: item.isQuotes
                            };
                        })
                    }
                    // if (!isDesktop) {
                    //     response.quotes = [];
                    // }
                    if (response.quotes.length > 0) {
                        response.quotes = response.quotes.map(item => {
                            return {
                                id: item.code,
                                nome: item.namePtBr,
                                namePtBr: item.namePtBr,
                                nameEnEu: item.nameEnEu,
                                nameEsAr: item.nameEsAr,
                                nameEsEs: item.nameEsEs,
                                namePtPt: item.namePtPt,
                                habilitado: item.active,
                                icone: item.icon,
                                isQuotes: item.isQuotes
                            };
                        })
                    }
                    response.analysis.unshift(AppConstants.INFORMATIVE_FILTER_ALL_OPTION);
                    if (themeConfig.client == AppConstants.PLATFORM_CLIENT.CMA) {
                        response.analysis.unshift({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Information_label, habilitado: true });
                    } else if (themeConfig.client == AppConstants.PLATFORM_CLIENT.SAFRAS) {
                        if (isDesktop) {
                            response.analysis.unshift({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Informative, habilitado: true });
                        }
                    }
                    if (isDesktop && response.quotes.length > 0) {
                        response.quotes.unshift({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Follow_Market, habilitado: true });
                    }
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }
    
    getAllCache(params) {
        return new Promise((resolve, reject) => {
            apiCacheService.get(AppConstants.URL_API_CACHE_GETALL, params)
                .then(response => {
                    response.latestNews = response.latestNews.map(item => {
                        // item.data_object = new Date(item.dt_create);
                        item.data_object = new Date(item.dt_publish)
                        item.reportDateFormat = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_report ? item.dt_report : item.dt_publish)
                        return item;
                    });
                    resolve(response.latestNews);
                })
                .catch(error => reject(error));
        });
    }

    getAllCacheHighlights(params) {
        return new Promise((resolve, reject) => {
            apiCacheService.get(AppConstants.URL_API_CACHE_GETALL_HIGHLIGHTS, params)
                .then(response => {
                    response.latestNews = response.latestNews.map(item => {
                        // item.data_object = new Date(item.dt_create);
                        item.data_object = new Date(item.dt_publish)
                        item.reportDateFormat = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_report ? item.dt_report : item.dt_publish)
                        return item;
                    });
                    resolve(response.latestNews);
                })
                .catch(error => reject(error));
        });
    }

    getContentPrivatePublicDetail(params) {
        return new Promise((resolve, reject) => {
            apiCacheService.get(AppConstants.URL_API_CACHE_CONTENT_PRIVATE_PUBLIC_DETAIL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getPlansCache(params) {
        return new Promise((resolve, reject) => {
            apiCacheService.get(AppConstants.URL_API_CACHE_PLANS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getContentPrivatePrivacyPolicy(params) {
        return new Promise((resolve, reject) => {
            apiCacheService.get(AppConstants.URL_API_CACHE_CONTENT_PRIVATE_PRIVACY_POLICY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    getContentPrivateQuotesPublic(params) {
        return new Promise((resolve, reject) => {
            apiCacheService.get(AppConstants.URL_API_CACHE_CONTENT_PRIVATE_QUOTES_PUBLIC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

}

export default new NewsHomeService();
